import { render, staticRenderFns } from "./SeqSends.vue?vue&type=template&id=9c60d812&"
import script from "./SeqSends.vue?vue&type=script&lang=ts&"
export * from "./SeqSends.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports